import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

import './DoveSiamo.css';

class DoveSiamo extends Component {

    render() {
        return (

            <Grid item xs={12} id='where'>
                {/* TODO: cambiare Api Key per Radio Gaga */}
                <h1 className='slide-title'>Dove Siamo</h1>
                <iframe width='100%' height='500px' frameBorder='0' style={{ border: '0' }} title='map'
                    src='https://www.google.com/maps/embed/v1/place?key=AIzaSyDTbJMVdlENw_pbTXCN9aqvIKZ_GESaERU&q=Radio+Gaga,Roma+IT' allowFullScreen>
                </iframe>
            </Grid>

        );
    }
}

export default DoveSiamo;